import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import ModalRequestADemo from '../modalRequestADemo/ModalRequestADemo';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ContactUsForm from '../contactUsForm/ContactUsForm';

const SubscribeNoctil = () => {
  const { pathname } = useLocation();

  const isShowContactUs = pathname.includes('get-30-day-free-trial');

  return (
    <div className="subscribeNoctil bg-gradient mt--85">
      <div className="container">
        <div className="row ">
          <div className="col-md-6">
            <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
              <h2>
                A complete <b>no-code metadata </b>platform to
              </h2>
              <h2>
                <b>maximize revenue</b>
              </h2>
              <h3 className="mt--30">
                For Music Publishers, Labels <br /> and Administrators
              </h3>
              <p>
                Simplify and fast-track bulk metadata transformation from multiple
                industry formats for accurate registration and timely revenue claiming.
              </p>
              <h3 className="mt--30">For Music Rights Organizations</h3>
              <p>
                Build high-quality metadata and match every single usage accurately.
                Accelerate royalty processing and effortlessly integrate any metadata
                sources.
              </p>
              {isShowContactUs ? null : (
                <div className="mt--40">
                  <ModalRequestADemo />
                </div>
              )}
            </ScrollAnimation>
          </div>
          <div className="col-md-6">
            <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
              {isShowContactUs ? (
                <ContactUsForm />
              ) : (
                <img
                  src="/assets/images/subscribe-noctil/subscribe-noctil.svg"
                  alt="Take the Best Step Forward with Noctil!"
                />
              )}
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SubscribeNoctil;
